import { render, staticRenderFns } from "./ForgotUsernameChooseScenario.vue?vue&type=template&id=0a3c2e47&"
import script from "./ForgotUsernameChooseScenario.vue?vue&type=script&lang=ts&"
export * from "./ForgotUsernameChooseScenario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports